import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import VendorListResults from 'components/Vendors/VendorListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  products: state.products,
  vendors: state.vendors,
  processes: state.processes,
  expenses: state.expenses,
  idGen: state.idGen,
  user: state.user
});

const VendorList = (props) => (
  <>
    <Helmet>
      <title>Vendors | Duot Khayat</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <VendorListResults
          activeUserId={props.activeUserId}
          products={props.products}
          vendors={props.vendors}
          processes={props.processes}
          expenses={props.expenses}
          idGen={props.idGen}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (VendorList);